// ** React Imports
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";

// ** Nearby Components
import { NearbyFilters } from "./NearbyFilters";
import { NearbyResultsDescription } from "./NearbyResultsDescription";
import useNearbyLocationSelector from "../hooks/useNearbyLocationSelector";
import useNearbySexSelector from "../hooks/useNearbySexSelector";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardTitle } from "components/layout/Card/CardTitle";
import Heading from "components/typography/Heading";
import { CardBody } from "components/layout/Card/CardBody";

// #####################################################

export const NearbyFiltersSection = ({ cityName, regionName, countryCode }) => {
	const { t } = useTranslation(["pages", "landing"]);

	const [filtersOpen, setFiltersOpen] = useState(false);

	const location = useLocation();
	const { state = {} } = location || {};
	const closeFiltersAfterLinkClick = state
		? state.closeFiltersAfterLinkClick
		: false;

	useEffect(() => {
		if (closeFiltersAfterLinkClick) {
			setFiltersOpen(false);
			location.state.closeFiltersAfterLinkClick = false;
		}
	}, [closeFiltersAfterLinkClick]);

	const { renderLocationSelector } = useNearbyLocationSelector({
		cityName,
		regionName,
		countryCode,
	});

	const { renderMultipleSexSelector } = useNearbySexSelector();

	// #####################################################

	return (
		<CardWrapper>
			<CardTitle>
				<Heading type="h2">{t("pages:nearby")}</Heading>
			</CardTitle>
			<CardBody>
				<Block flex column>
					<NearbyResultsDescription
						filtersOpen={filtersOpen}
						setFiltersOpen={setFiltersOpen}
						cityName={cityName}
						regionName={regionName}
						countryCode={countryCode}
					/>

					{filtersOpen && (
						<NearbyFilters
							setFiltersOpen={setFiltersOpen}
							renderLocationSelector={renderLocationSelector}
							renderMultipleSexSelector={
								renderMultipleSexSelector
							}
						/>
					)}
				</Block>
			</CardBody>
		</CardWrapper>
	);
};

// #####################################################
